module.exports = __webpack_public_path__ + "static/media/river_sunset.8bb875bc.jpeg";